export const SELF_ASSESSMENT_PROCESS = [
    <p>Enter some organisational details</p>,
    <p>
        <b>Score</b> yourself against questions covering Environment, Workers,
        Community & Governance
    </p>,
    <p>
        <b>Get your results:</b> your self-assessment results area available
        immediately.
    </p>,
    <p>
        <b>Check your next steps</b> and plan how to improve!
    </p>,
    <p>
        When you're ready, <b>switch to validation track and upload evidence.</b>
    </p>,
];

export const VALIDATION_PROCESS = [
    <p>Enter some organisational details</p>,
    <p>
        <b>Score</b> yourself against questions covering Environment, Workers,
        Community & Governance
    </p>,
    <p>
        <b>Upload evidence</b> for each question, following the guidance provided.
    </p>,
    <p>
        Answer additional(non-scored) <b>ESG stats questions</b> (optional)
    </p>,
    <p>
        <b>Get your provisional results:</b> your unvalidated results are available
        immediately.
    </p>,
    <p>
        <b>Submit for verification:</b> confirm you have uploaded your evidence and
        pay the <b>verification fee</b>
    </p>,
    <p>
        <b>Additional evidence requests/ clarifications from validator</b>
    </p>,
    <p>
        <b>Final score approved:</b> Score provided to you as "VERIFIED" and
        published via LEGACY's ESG data platform
    </p>,
    <p>
        <b>Check your next steps</b> and plan how to improve!
    </p>,
];
